import StepRoute from '../classes/step-route.class';

import RouteNames from '../constants/route-names';
import AppointmentConfirmationRoute from './appointment-confirmation.route';
import AppointmentContactRoute from './appointment-contact.route';
import AppointmentCreateAccount from './appointment-createaccount.route';
import AppointmentPropertyRoute from './appointment-property.route';
import AppointmentScheduleRoute from './appointment-schedule.route';
import AppointmentServicesRoute from './appointment-services.route';
import AppointmentSignIn from './appointment-signin.route';
import AppointmentSummaryRoute from './appointment-summary.route';
import RouteGuards from './appointment.guards';

const route = new StepRoute(
  RouteNames.Appointment,
  '/:companyId',
  () => import('@/views/steps/StepController.vue'),
);

route.hasChildRoutes([
  AppointmentScheduleRoute,
  AppointmentServicesRoute,
  AppointmentPropertyRoute,
  AppointmentSignIn,
  AppointmentCreateAccount,
  AppointmentContactRoute,
  AppointmentConfirmationRoute,
  AppointmentSummaryRoute,
]);

route.navigationGuard(async (to, from, next) => {
  try {
    await RouteGuards.validateAndHydrate(to.params.companyId);
    RouteGuards.handleInitialRedirect(to, next);
  } catch (err) {
    const errorRoute = await RouteGuards.getHydrationErrorRoute(to, err);
    if (errorRoute) {
      next({ name: errorRoute, params: to.params });
    } else {
      RouteGuards.handleInitialRedirect(to, next);
    }
  }
});

export default route.getRoute();
